module.exports = __webpack_public_path__ + "img/inactive-stepper.ade6d3c9.svg";